import { lang } from "../../../../i18nLang";
import { IColumn } from "../../MuiVirtualizedTable/Cells";
import { CellEditDescription } from "../CellEditDescription";
import { CellTooltip } from "../TableStickers";

export const columns: IColumn[] = [
  {
    width: 120,
    label: lang("fields.code"),
    dataKey: "code",
    cellComponent: CellTooltip,
  },
  {
    width: 500,
    label: lang("fields.description"),
    dataKey: "description",
    flexGrow: 2,
    cellComponent: CellEditDescription,
  },
  {
    width: 144,
    label: lang("fields.quantity"),
    dataKey: "quantity",
    align: "right",
    input: false,
  },
  {
    width: 96,
    label: lang("fields.unit"),
    dataKey: "unit",
    align: "center",
  },
  {
    width: 144,
    label: `${lang("fields.unitCostShort")} (${lang("currency")})`,
    dataKey: "unitCost",
    align: "right",
    headComponent: CellTooltip,
  },
  {
    width: 144,
    label: `${lang("fields.total")} (${lang("currency")})`,
    dataKey: "total",
    align: "right",
  },
  {
    width: 96,
    label: "%",
    dataKey: "perc",
    align: "center",
  },
];
